import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "update-profile-page w-690" }
const _hoisted_2 = { class: "nav nav-tabs my-4" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "编辑个人资料", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "点击上传头像", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-large" }, "提交修改", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uploader = _resolveComponent("uploader")!
  const _component_validate_input = _resolveComponent("validate-input")!
  const _component_validate_form = _resolveComponent("validate-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          href: "#",
          class: _normalizeClass(_ctx.generateActiveClass('profile')),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.switchTab('profile')), ["prevent"]))
        }, " 更新个人资料 ", 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: "#",
          class: _normalizeClass(_ctx.generateActiveClass('column')),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.switchTab('column')), ["prevent"]))
        }, " 更新专栏信息 ", 2)
      ])
    ]),
    _hoisted_4,
    _createVNode(_component_uploader, {
      action: "/upload",
      class: "d-flex align-items-center justify-content-center bg-light text-secondary circle mx-auto my-3",
      beforeUpload: _ctx.commonUploadCheck,
      uploaded: _ctx.uploadedData,
      onFileUploaded: _ctx.onFileUploaded
    }, {
      uploaded: _withCtx((dataProps) => [
        _createElementVNode("img", {
          src: dataProps.uploadedData.data.url + '?x-oss-process=image/resize,m_fill,h_200,w_200'
        }, null, 8, _hoisted_5)
      ]),
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["beforeUpload", "uploaded", "onFileUploaded"]),
    _createVNode(_component_validate_form, {
      ref: "formRef",
      onFormSubmit: _ctx.onFormSubmit
    }, {
      submit: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _createVNode(_component_validate_input, {
          rules: _ctx.nameRules,
          placeholder: "请输入名称",
          modelValue: _ctx.nameValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nameValue) = $event)),
          type: "text"
        }, null, 8, ["rules", "modelValue"]),
        _createVNode(_component_validate_input, {
          rules: _ctx.descRules,
          placeholder: "请输入简介信息",
          modelValue: _ctx.descValue,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.descValue) = $event)),
          rows: "5",
          tag: "textarea"
        }, null, 8, ["rules", "modelValue"])
      ]),
      _: 1
    }, 8, ["onFormSubmit"])
  ]))
}